import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { AlertService } from './alert.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class PointsService {

  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    private commonService: CommonService,
    private alertService: AlertService
  ) { }

  getPointById(idPoint): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getPointById/' + idPoint;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
  getPointByUser(userAccount): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getCtrlPointByUser/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getPointByUser_filtered(userAccount, typesId): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getCtrlPointByUser_filtered/' + userAccount + "/" + typesId;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getCtrlPointTypes(): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getCtrlPointTypes';
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getPoints(idRoute): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getCtrlPts/' + idRoute;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
  saveUpdatePoint(point:any): Promise<any>{
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/saveCtrlPt',
      JSON.stringify(point), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        if (response && response['message']) {
          //this.alertService.success(response['message']);
          } else {
          //this.alertService.error('error')
        }
        return response;
      });
  }
  deletePoint(id: any): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/deleteCtrlPt';
    var param = { "Id" : id };
    return this.http.post(url, JSON.stringify(param), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; ; charset=UTF-8'
      }
    }).toPromise().then(obj => {
        const response = JSON.parse(obj.toString());
        console.log('response delete : ', response)
        return response;
    });
  }
  getTypePoint(): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getTypePt/';
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
  saveUpdateCheckingPoint(point:any): Promise<any>{
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/saveRouteCtrlPtWithTimes',
      JSON.stringify(point), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        if (response && response['message']) {
          //this.alertService.success(response['message']);
          } else {
          //this.alertService.error('error')
        }
        return response;
      });
  }


  savePicoTime(picoTime:any): Promise<any>{
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/savePicoTime',
      JSON.stringify(picoTime), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        console.log(obj)
        return response;
      });
  }

  deleteCheckingPoint(id: any): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/deleteRouteCtrlPt';
    var param = {
              "Id" : id
    };
    return this.http.post(url, JSON.stringify(param), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; ; charset=UTF-8'
      }
    }).toPromise().then(obj => {
        const response = JSON.parse(obj.toString());
        console.log('response delete : ', response)
        return response;
    });
  }
  getCheckingPoints(idRoute): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRouteCtrlPt/' + idRoute;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
  getTypeCheckingPoint(userAccount): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getTypeChecking/'+userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getTypeCheckingPoint_rol(userAccount): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getTypeChecking_rol/'+userAccount + "/" + this.commonService.getUserRole();;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getCheckingPoint(id): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getCheckingPoint/' + id;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }


  getPicoTimes(userAccount): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getPicotimes/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  deletePicoTime(id): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/deletePicoTime/' + id;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        console.log(obj)
        return obj;
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/points.service.ts